import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataRouting = require("lib/routing/DataRouting");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var AltBoard = require("components/utility/AltBoard");
var ExerciseTile = require("components/writing/activities/ExerciseTile");
var ItemHeader = require("components/data/subjects/shared/ItemHeader");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "textID", "userIDs"
	);

	return conditions;
}

@connect(
	(state, props) => ({
		loading: WritingSelectors.isLoadingResponses({ state }),
		responses: WritingSelectors.responses({
			state, conditions: propsToConditions(props)
		})
	}),
	(dispatch, props) => ({
		populateData: () => {
			return dispatch(WritingActions.fetchResponses({
				conditions: propsToConditions(props), 
				embeds: ["response.activity", "activity.format_summary"],
				cache: true
			}))
		}
	})
)
@providePopulateData()
class DataExercises extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("DataExercises");
	}

	render() {
		var exercisesDisplay = []
		var studentsWithoutExercises = []

		_.each(this.props.userIDs, (studentID) => {
			var responses = _.where(this.props.responses, { user_id: studentID });
			if (responses.length > 0) {
				var tiles = _.map(responses, (response) => {
					return (
						<ExerciseTile responseID={ response.id } key={ response.id }
							smallThumbnail allowExpandResponse />
					);
				});
				exercisesDisplay.push(
					<div key={ studentID }>
						<ItemHeader studentID={ studentID } pageBreak />
						<AltBoard narrowBoard>
							{ tiles }
						</AltBoard>
					</div>
				)
			} else {
				studentsWithoutExercises.push(studentID)
			}
		});

		if (studentsWithoutExercises.length > 0) {
			var noExcersises = <NoActivityBlock userIDs={ studentsWithoutExercises } contentType="Exercises" />
		}

		var display = (
			<div>
				{ exercisesDisplay }
				{ noExcersises }
			</div>
		)

		return (
			<div className="dataExercises">
				{ display }
			</div>
		)
	}
}
DataExercises.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showFullData: PropTypes.bool,

	// Data from @connect
	loading: PropTypes.bool,
	responses: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataExercises;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataExercises.js